export const Svg_122 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M32.886 46.083h4.302V31.937l5.76 5.906 3.136-3.135-11.157-11.083-11.083 11.083 3.136 3.135 5.906-5.906v14.146Zm-22.677 12.25c-1.167 0-2.188-.438-3.063-1.313s-1.312-1.895-1.312-3.062V16.04c0-1.166.437-2.187 1.312-3.062s1.896-1.313 3.063-1.313h49.583c1.167 0 2.188.438 3.063 1.313s1.312 1.896 1.312 3.062v37.917c0 1.167-.437 2.187-1.312 3.062s-1.896 1.313-3.063 1.313H10.21Zm0-4.375h49.583V16.04H10.21v37.917Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={39.015}
        y1={18.666}
        y2={58.504}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)